export { Lightbox } from './Lightbox';
export { AddNewElementRow } from './AddNewElementRow';
export type { AddingNewElement } from './AddNewElementRow';
export { CharacterGroup } from './CharacterGroup';
export { ScenePropGroup } from './ScenePropGroup';
export type { ElementType } from '../types';

export function tryParseJSON<T>(json: string): T {
  try {
    const parsed = JSON.parse(json);
    return (parsed ?? []) as T;
  } catch { return [] as unknown as T; }
}
